import { getVisitorId } from 'src/hooks/useUserCookies';

import { isInExperiment } from './experimentHelper';
import {
  type FeatureFlagsName,
  isFeatureFlag as isFeatureFlagOverride,
} from './featureFlag';

interface FeatureExperimentRollout {
  featureToggle: FeatureFlagsName;
  experimentName: string;
  rolloutPercentage: number;
}

export const featureExperimentRollout = ({
  featureToggle,
  experimentName,
  rolloutPercentage,
}: FeatureExperimentRollout) =>
  isFeatureFlagOverride(featureToggle) ||
  isInExperiment({
    userId: getVisitorId(),
    experimentName,
    rolloutPercentage,
  });
